import { z } from 'zod';
import { PartnerMaterialLocaleSchema } from '../../entities/partner-material/partner-material.schema';
/**
 * Get Partner Material Download
 * GET /api/v2/partner/materials/:id/download?locale=de
 *
 * Falls back to English, then German, then any stored language; `locale` in the response
 * names the language actually served.
 */ export const GetPartnerMaterialDownloadQuerySchema = z.object({
    locale: PartnerMaterialLocaleSchema.optional()
});
export const GetPartnerMaterialDownloadResponseSchema = z.object({
    url: z.string(),
    locale: PartnerMaterialLocaleSchema
});

//# sourceMappingURL=get-partner-material-download.schema.js.map